import * as t from 'io-ts';
import { nonEmptyString } from '../utils';

const Honeybadger = t.exact(t.interface({
  apiKey: nonEmptyString,
  disabled: t.boolean,
}), 'Honeybadger');

export type IHoneybadger = t.TypeOf<typeof Honeybadger>;

export default Honeybadger;
